import { withStyles } from "@material-ui/core";
import React from "react";
import DataGrid from "../../../../dataGrid";
import StatusBar from "../../../../dataGrid/StatusBar";
import GridHeader from "../../components/GridHeader";
import GridConfig from "./gridConfig";
import { isEqual } from "lodash";
import { getSpecialNeeds } from "../../../utils";
import { compose } from 'recompose';
import { withAppConfig } from "../../../../../appConfigContext";
import styles from "../../common/GridStyles";
import Events from "../../../../../utilities/EventEmitter";

class NewShipmentsGrid extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchText: "",
    };
    this.gridConfig = new GridConfig({
      userConfig: this.props.userProfile?.columnPref,
      columnConfig: this.props.configJSON?.gridColumnConfig,
      terminal: this.props.userProfile?.terminal.code,
    });
    this.gridContext = {
      specialNeedsOptions: getSpecialNeeds(this.props.serviceLevelList),
    };
  }

  componentDidMount() {
    Events.on("addNewShipmentsGrid", this.onSearchTextChanged);
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.serviceLevelList, this.props.serviceLevelList)) {
      this.gridContext = {
        specialNeedsOptions: getSpecialNeeds(this.props.serviceLevelList),
      };
    }
  }

  componentWillUnmount() {
    Events.off("addNewShipmentsGrid", this.onSearchTextChanged);
  }

  onSearchTextChanged = (searchText) => {
    this.setState({
      searchText,
    });
  };

  constructStatusBar = (filteredData) => {
    return [
      {
        label: filteredData.length + " Shipments",
        filterCondition: "",
      },
    ];
  };

  isRowSelectable = (params) => {
    return !params.data.isInPlan;
  };

  render() {
    const { config } = this.gridConfig;
    const { classes, ...otherProps } = this.props;
    return (
      <div className={`${classes.dataGrid} ${classes.gridContent}`}>
        <GridHeader
          title="New Shipments"
          headerId="addNewShipmentsGrid"
          glEventHub={Events}
        />
        <DataGrid
          defaultColDef={config.defaultColDef}
          columnDefs={config.columns}
          config={config}
          rowSelection={config.rowSelection}
          rowDeselection={config.rowDeselection}
          deltaRowDataMode={true}
          quickFilterText={this.state.searchText}
          suppressRowClickSelection
          panelLabel={(filteredData) => (
            <StatusBar data={this.constructStatusBar(filteredData)} />
          )}
          context={this.gridContext}
          rowClassRules={config.rowClassRules}
          isRowSelectable={this.isRowSelectable}
          getRowNodeId={(data) => data.proId}
          {...otherProps}
        />
      </div>
    );
  }
}

export default compose(withAppConfig, withStyles(styles))(NewShipmentsGrid);
